<template>
    <div class="scan-graphic d-flex flex-column justify-content-center align-items-center">
        <i v-if="scanIsBusy" class="fa-duotone fa-spinner fa-spin fa-10x text-primary"></i>
        <i v-else-if="scanError" class="fa-duotone fa-circle-exclamation fa-10x text-warning"></i>
        <i v-else class="fa-duotone fa-scanner fa-10x"></i>
        <div class="display-4 mt-4 text-muted">Scan Package to Begin</div>
    </div>
</template>

<script>
    export default {
        name: 'intake-scan',
        data() {
            return {
                scanIsBusy: false,
                scanError: false,
            };
        },
        mounted() {
            this.$barcodeScanner.init(rawBarcode => {
                this.$barcodeScanner.parseBarcode(rawBarcode, (barcode, context) => {
                    if(this.$route.params.id == barcode) {
                        this.$parent.$bvModal.msgBoxOk("Order " + barcode + " is already loaded!", {
                            title: "Order already loaded",
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                        return;
                    }
                    if (context === 'O' || context === 'R') {
                        this.$router.push({path: '/returns/view/' + encodeURIComponent(barcode)});
                    } else {
                        this.scanIsBusy = true;
                        this.$http.get('/reverse-shipments/scan/' + barcode)
                            .then(response => {
                                if (response.data.id) {
                                    this.$router.push({path: '/returns/view/' + response.data.id});
                                } else {
                                    this.scanIsBusy = false;
                                    this.scanError = true;
                                    setTimeout(() => {
                                        this.scanError = false;
                                    }, 2000);
                                }
                            })
                            .catch(() => {
                                this.scanIsBusy = false;
                                this.scanError = true;
                                setTimeout(() => {
                                    this.scanError = false;
                                }, 2000);
                            });
                    }
                });
            });
        },
        beforeDestroy() {
            this.$barcodeScanner.destroy();
        },
    };
</script>

<style scoped>
    i {
        font-size: 18rem;
        color: gray;
    }

    .scan-graphic {
        height: 75vh;
    }
</style>
